import styled, { css } from 'styled-components';
import { nullCoalesc } from '../../../utils/objects';

interface IContentBox {
	padding?: number | string;
	marginTop?: number;
	marginBottom?: number;
	height?: number;
	minHeight?: number;
	maxHeight?: number;
	margin?: number;
}

export const ContentBox = styled.div<IContentBox>`
	padding: ${({ padding }) => nullCoalesc(padding, css`1.5rem`)};
	background-color: #ffffff;
	box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15), 0 2px 3px rgba(0, 0, 0, 0.2);
	overflow: hidden;
	border-radius: 4px;
	margin-top: ${({ marginTop, margin }) => nullCoalesc(marginTop, margin, 16)}px;
	margin-bottom: ${({ marginBottom, margin }) => nullCoalesc(marginBottom, margin, 16)}px;
	min-height: ${({ minHeight, height }) => nullCoalesc(minHeight, height, 300)}px;
	transition: all 0.2s;
	max-height: ${({ maxHeight, height }) => {
		let h = nullCoalesc(maxHeight || height, null);
		if (h) return `${h}px`;
		return 'none';
	}};
	text-overflow: ellipsis;
	white-space: wrap;
	word-break: break-word;
`;
export const HovrableBox = styled(ContentBox)`
	backface-visibility: hidden;
	-webkit-font-smoothing: antialiased;
	filter: blur(0);
	&:hover {
		/* transform: scale3d(1.01, 1.01, 1); */
		box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15), 0 2px 3px 3px rgba(0, 0, 0, 0.2);
		z-index: 100;
	}
`;
